(() => {
  'use strict';
  if (typeof window.NiralaDiscountOffer?.init === 'function') {
    window.NiralaDiscountOffer.init();
    return;
  }
  const copying = new WeakSet();
  function init() {
    document.querySelectorAll('[data-discount-offer] [data-discount-copy]').forEach(button => { button.hidden = false; });
  }
  async function copyCode(event) {
    const button = event.target.closest('[data-discount-copy]');
    if (!button || copying.has(button)) return;
    const offer = button.closest('[data-discount-offer]');
    const input = offer?.querySelector('[data-discount-code]');
    const status = offer?.querySelector('[data-discount-status]');
    if (!input?.value || !status) return;
    copying.add(button);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.textContent = '';
    try {
      if (typeof navigator.clipboard?.writeText !== 'function') throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(input.value);
      if (offer.isConnected) status.textContent = offer.dataset.copiedMessage;
    } catch (_) {
      if (offer.isConnected) {
        input.focus({ preventScroll: true });
        input.select();
        input.setSelectionRange(0, input.value.length);
        status.textContent = offer.dataset.copyFailedMessage;
      }
    } finally {
      copying.delete(button);
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('click', copyCode);
  document.addEventListener('shopify:section:load', init);
  window.NiralaDiscountOffer = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
